export default __webpack_public_path__ + "static/media/balcony.fbea84d1.svg";